// extracted by mini-css-extract-plugin
export default {"dek":"dek__MmIxY","question":"question__NDE0Y","questionPlaceholder":"questionPlaceholder__MWIxM","redesignQuestion":"redesignQuestion__MWMzM"};